export const RoutePostMerchflows_merchflowId_Duplicate = "/merchflows/:merchflowId/duplicate";

export interface ParamsPostMerchflows_merchflowId_Duplicate {
  merchflowId: string;
}

export interface PayloadPostMerchflows_merchflowId_Duplicate {
  name?: string;
  include_all_pog_versions: boolean;
  store_codes: string[] | null;
  /** Re-read movement, sales, profit and price from current product data into the copied pogs. */
  refresh_sales?: boolean;
}

export interface DuplicateMerchflowSalesRefreshSummary {
  pog_count: number;
  /** Product codes with no current product data; they keep the source pog's values. */
  unmatched_product_count: number;
}

export interface ResponsePostMerchflows_merchflowId_Duplicate {
  id: number;
  name: string;
  category_code: string;
  retailer_category_code: string;
  notes: string | null;
  status: string;
  go_live_date: string | null;
  deactivation_date: string | null;
  created_at: string | null;
  updated_at: string | null;
  skipped_count: number;
  sales_refresh: DuplicateMerchflowSalesRefreshSummary | null;
}
